import { isEmpty } from 'lodash';

export const handleOperatorProviderId = (value: any) => {
  if (isEmpty(value)) {
    return 'Please select provider name.';
  }
  return null;
};

export const handleOperatorApplicationId = (value: any) => {
  if (isEmpty(value)) {
    return 'Please select application name.';
  }
  return null;
};
